var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProponenteItem.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-234f0ae3\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProponenteItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/controle-de-solicitacoes/detalhes-da-solicitacao/components/ProponenteItem.vue
// module id = 1048
// module chunks = 1